const perlin = require('RandomPerlin');

cc.Class({
    extends: cc.Component,

    ctor () {
        this._isZooming = false;
        this.zoomInCameraTo = 5;
        this.shakeCamera = false;
        this.deltaDiff = 0;
        this._zoomeEffectTween = null;
    },

    properties: {
        camera: cc.Camera,
        zoomSpeed: 0.2,
        zoomLimit: 1.21,
        screenRatio: 0.4,
        _currentZoom: 1,
        isUsePerlin: true
    },

    // LIFE-CYCLE CALLBACKS:

    start () {
        this._currentZoom = this.camera.zoomRatio;
        this._origCamPos = this.camera.node.position.clone();
        if (!this.camera) {
            throw new Error('camera property is null');
        }
    },

    stopZoomTween () {
        if (this.zoomTween) {
            this.zoomTween.stop();
            this.zoomTween = null;
            this.zoomResolve();
        }
    },

    resetCamera () {
        if (this.moveTween) {
            this.moveTween.stop();
            this.moveTween = null;
        }
        this._isZooming = false;
        this.camera.zoomRatio = 1;
        this.camera.node.x = 0;
        this.camera.node.y = 0;
        this.camera.node.angle = 0;

        this._currentZoom = 1;
    },

    zoomToPosition (zoomLevel, time, zoomPos, easing = null) {
        if ((this.camera.zoomLevel + zoomLevel) >= this.zoomLimit) {
            return;
        }
        this._currentZoom = this.camera.zoomRatio;
        this._isZooming = true;
        easing = easing || cc.easing.sineInOut;

        // eslint-disable-next-line no-underscore-dangle
        const _zoomPos = zoomPos;

        return new Promise((resolve) => {
            this.moveTween = cc.tween(this.camera.node).
                to(time, { x: _zoomPos.x, y: _zoomPos.y }, { easing }).
                call(() => {
                    this.moveTween = null;
                }).
                start();

            cc.tween(this).
                to(time, { _currentZoom: zoomLevel },  { easing }).
                call(() => {
                    this._isZooming = false;
                    resolve();
                }).
                start();
        });
    },

    zoomBy (zoomLevel, time, easing = null) {
        if ((this.camera.zoomRatio + zoomLevel) >= this.zoomLimit) {
            return;
        }
        this._currentZoom = this.camera.zoomRatio;
        this._isZooming = true;
        easing = easing || cc.easing.sineInOut;

        return new Promise((resolve) => {
            cc.tween(this).
                by(time, { _currentZoom: zoomLevel },  { easing }).
                call(() => {
                    this._isZooming = false;
                    this.zoomResolve = resolve;
                }).
                start();
        });
    },

    zoomTo (zoomLevel, time, easing = null) {
        if ((zoomLevel) >= this.zoomLimit) {
            return;
        }

        easing = easing || cc.easing.sineInOut;
        this._currentZoom = this.camera.zoomRatio;
        this._isZooming = true;

        return new Promise((resolve) => {
            this.zoomResolve = resolve;
            this.zoomTween = cc.tween(this).
                to(time, { _currentZoom: zoomLevel },  { easing }).
                call(() => {
                    this.updateCameraZoom();
                    this.zoomTween = null;
                    this._isZooming = false;
                    resolve();
                }).
                start();
        });
    },

    finishShake() {
        this.unscheduleAllCallbacks();
        this.shakeCamera = false;
        this.camera.node.position = this._origCamPos.clone();
        this.node.emit('shake-end');
    },

    shake (intensitiy = 3.0, time = 0.3, shakeSpeed = 10.0) {
        if (!this.camera && !this.camera.node) {
            return;
        }

        if(this.shakeCamera) {
            this.finishShake();
        }

        return new Promise((resolve) => {
            this.shakeCamera  = true;
            this._shakeTime = time;
            this._shakeElapsed = 0;
            this._shakeIntensity = intensitiy;
            this._shakeSpeed = shakeSpeed;
            this._shakeRandomStart = (Math.random() * 2000) - 1000;

            this.node.once('shake-end', () => {
                resolve();
            });

            this.scheduleOnce(() => {
                this.finishShake();
            }, time);
        });
    },

    updateCameraZoom () {
        if (!this._isZooming) {
            return;
        }
        const ratio = cc.view.getVisibleSize().width / cc.Canvas.instance.designResolution.width;

        const { camera } = this;

        // we only want the zoom effect in landscape

        if (ratio > this.screenRatio) {
            this.camera.zoomRatio = this._currentZoom;

            return true;
        }
        // in portrait we don't want to zoom in because reels get out of bounds
        camera.zoomRatio = 1;

        return false;
    },

    updateShake (delta) {
        if (!this.shakeCamera) {
            return;
        }

        if (this.deltaDiff < 0.3) {
            this.camera.node.angle = (Math.random() > 0.5 ? 1 : -1) * Math.random();
        } else {
            this.camera.node.angle = 0;
        }
        this.deltaDiff += delta;

        if (this.deltaDiff > 0.5) {
            this.deltaDiff = 0;
        }
    },

    perlinShake (delta) {
        if (!this.shakeCamera) {
            return;
        }

        const percentComplete = this._shakeElapsed / this._shakeTime;
        const damper  = 1.0 - cc.misc.clampf(4.0 * percentComplete - 3.0, 0, 1);
        const alpha = this._shakeRandomStart +  this._shakeSpeed  * percentComplete;

        let newX = perlin.perlin3(alpha, 0, 0);
        let newY = perlin.perlin3(0, alpha, 0);

        newX *= this._shakeIntensity * damper;
        newY *= this._shakeIntensity * damper;

        this.camera.node.position = new cc.Vec2(newX, newY);

        this._shakeElapsed += delta;
    },

    update (delta) {
        this.updateCameraZoom();
        if (this.isUsePerlin) {
            this.perlinShake(delta);
        } else {
            this.updateShake(delta);
        }

    }
});
